import { api } from "./axios";

export async function getNotifications() {
    let res = await api.get("notifications/unread");
    if (res) return res.data.data;
    else return false;
}

export async function readNotifications(id) {
    let res = await api.post("notifications/" + id + "/read");
    if (res) return res.status;
    else return false;
}